import { UseMutationOptions } from '@tanstack/react-query';

import { CommunicationType } from 'domains/content/types';
import useMutation from 'hooks/useMutation';
import { CuredApiPaths } from 'models/enums';

import MutationKeys from './keys';

export type CreateDirectMailInput = {
    applicationsAccess: string;
    communicationType: CommunicationType;
    name: string;
    html: string;
    design: any; // TODO: use real type from unlayer
    htmlMultilingual?: Record<string, string>;
    designMultilingual?: Record<string, any>;
};

const useCreateDirectMail = (mutateOptions: UseMutationOptions<unknown, Error, CreateDirectMailInput>) =>
    useMutation<CreateDirectMailInput>(MutationKeys.CREATE_DIRECT_MAIL, CuredApiPaths.DIRECT_MAIL, mutateOptions);

export default useCreateDirectMail;
